/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import { createSearchParams, useLocation, useSearchParams } from 'react-router-dom'
import slugify from 'slugify'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { RouteValue, useLink } from 'routes/cmsRoutes'
import FAQ from 'pagesNew/FAQ'
import { FaqPages } from '__generatedTypes__/globalTypes'
import { AwardsTabs } from './consts'
import * as classes from './styles'
import { AchievementsList } from './components/AchievementsList'
import { RewardsList } from './components/Rewards/List'

const TABS = Object.values(AwardsTabs).map((item) => ({ id: item, title: item }))

export const QUERY_PARAM = 'tab'

export const Achievements: FC = () => {
  const location = useLocation()
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return TABS.find(({ id }) => slugify(id, { lower: true }) === tabId) || TABS[0]
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    navigate(location.pathname as RouteValue, undefined, {
      searchParams: createSearchParams({ [QUERY_PARAM]: slugify(activeTab.id, { lower: true }) }),
    })
    setActiveTab(activeTab)
  }

  const renderTab = () => {
    const { title } = activeTab

    if (title === AwardsTabs.ACHIEVEMENTS) {
      return <AchievementsList />
    }

    if (title === AwardsTabs.REWARDS) {
      return <RewardsList />
    }

    if (title === AwardsTabs.DESCRIPTION) {
      return (
        <div css={classes.descriptionsWrapper}>
          <DescriptionForm page={DescriptionPages.Awards} title="Achievements Description" />
          <DescriptionForm page={DescriptionPages.Rewards} title="Rewards Description" />
        </div>
      )
    }

    if (title === AwardsTabs.FAQ) {
      return <FAQ page={FaqPages.AchievementsAndRewards} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Achievements & Rewards
      </Typography>

      <TabsNavigation tabs={TABS} value={activeTab} onChange={handleChangeTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
